export const NEW_PATH = '/';
export const EDIT_PATH = '/edit';
export const VIEW_PATH = '/view';
export const PRO_VIEW_PATH = '/v2/assessments/:id';

export const ROUTES = [NEW_PATH, EDIT_PATH, VIEW_PATH, PRO_VIEW_PATH];
